import EnterpriseObjectMemberMetadata from "../../EnterpriseObjectMemberMetadata";
import EnterpriseObjectMetadata from "../../EnterpriseObjectMetadata";

class PositionEnterpriseObjectMetadata extends EnterpriseObjectMetadata {

    constructor() {
        super();

        this.name = "Position";
        this.primaryEnterpriseComponent = "Position";

        let eom: EnterpriseObjectMemberMetadata = new EnterpriseObjectMemberMetadata();
        eom.name = "Position";
        eom.enterpriseComponent = "Position";
        eom.relationship = undefined;
        this.enterpriseComponentMembers.set(eom.name, eom);

        eom = new EnterpriseObjectMemberMetadata();
        eom.name = "PositionAccountUser";
        eom.enterpriseComponent = "PositionAccountUser";
        eom.relationship = "PositionPositionAccountUser";
        this.enterpriseComponentMembers.set(eom.name, eom);

    }
}

export default PositionEnterpriseObjectMetadata;